import { render, staticRenderFns } from "./ErrorCard.vue?vue&type=template&id=839e5dae&scoped=true&"
import script from "./ErrorCard.vue?vue&type=script&lang=js&"
export * from "./ErrorCard.vue?vue&type=script&lang=js&"
import style0 from "./ErrorCard.vue?vue&type=style&index=0&id=839e5dae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839e5dae",
  null
  
)

export default component.exports